/**
 * Sequential Batch 23 service-link map entries.
 *
 * Merged into SERVICE_LINK_MAP at module load.
 * See INTERNAL_LINKING_GUIDE.md for the linking rules.
 */
import type { ServiceLinkEntry } from "@/lib/serviceLinkTypes";

export const BATCH23SEQ_SERVICE_LINKS: Record<string, ServiceLinkEntry> = {
  // Voice-AI posts → /voice-ai-vapi-automation
  "vapi-and-twilio-voice-automation-developer-freelance-v2": {
    url: "/voice-ai-vapi-automation",
    anchor: /Vapi and Twilio voice automation developer/i,
    label: "hire a Voice AI automation specialist",
  },
  "how-to-automate-incoming-lead-calls-with-ai-agents-v2": {
    url: "/voice-ai-vapi-automation",
    anchor: /automate incoming lead calls with AI agents/i,
    label: "hire a Voice AI automation specialist",
  },
  // AI/automation/orchestration posts → /n8n-workflow-developer
  "ai-objection-handling-workflow-setup-crm-v2": {
    url: "/n8n-workflow-developer",
    anchor: /AI objection handling workflow setup/i,
    label: "hire an n8n workflow developer",
  },
  "automated-lead-response-workflow-under-30-seconds-v2": {
    url: "/n8n-workflow-developer",
    anchor: /automated lead response workflow/i,
    label: "hire an n8n workflow developer",
  },
  "real-time-data-syncing-with-ai-crm-integrations-v2": {
    url: "/n8n-workflow-developer",
    anchor: /Webhook Orchestration/i,
    label: "hire an n8n workflow developer",
  },
  "can-general-virtual-assistant-build-automation-workflows": {
    url: "/n8n-workflow-developer",
    anchor: /automation workflows/i,
    label: "hire an n8n workflow developer",
  },
  // RevOps/fractional → /gohighlevel-revops-architect
  "fractional-revenue-operations-revops-architect-remote-v2": {
    url: "/gohighlevel-revops-architect",
    anchor: /fractional revenue operations revops architect remote/i,
    label: "hire a fractional RevOps architect",
  },
  // CRM-skills post → /gohighlevel-revops-architect
  "what-skills-to-look-for-in-crm-virtual-assistant": {
    url: "/gohighlevel-revops-architect",
    anchor: /CRM virtual assistant/i,
    label: "hire a CRM automation architect",
  },
  // Hiring/sourcing posts (when-to-hire, software-stacks) → homepage via HIRING_TOPIC_SLUGS.
};
